module.exports = __webpack_public_path__ + "img/um-round.bdfbb855.svg";